import { useDisplayModeData } from '@/hooks/use-display-mode-data';
import { useUser } from '@/hooks/use-user';
import { cn } from '@/lib/utils';
import {
  ColumnFilterId,
  useSetColumnFilter,
} from '@/states/column-filters.state';
import { displayModeState } from '@/states/display-mode.state';
import { useAtom } from 'jotai';

import { TabConfig, TabIcon } from './displaymode-buttons';

function DisplayModeButtonTabs({ tabs }: { tabs: TabConfig[] }) {
  const { getDisplayModeLabel, getDisplayModeCount } = useDisplayModeData();
  const [displayMode, setDisplayMode] = useAtom(displayModeState);
  const user = useUser();

  const { setColumnFilter } = useSetColumnFilter();

  return (
    <div
      className={cn('inline-flex items-center rounded-md bg-muted h-10 p-1')}
    >
      {tabs.map(({ mode, dataUserGuide }) => {
        const isActive = displayMode === mode;
        const count = getDisplayModeCount(mode);
        const label = getDisplayModeLabel(mode);

        const tabButtonClass = cn(
          'group inline-flex h-full items-center whitespace-nowrap rounded-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
          'py-1.5 text-sm gap-2 px-3',
          !isActive && `text-muted-foreground hover:text-foreground`,
          isActive && 'bg-background text-foreground shadow-sm'
        );

        const handleClick = () => {
          setColumnFilter(ColumnFilterId.__displayMode, mode);
          setDisplayMode(mode);
        };

        return (
          <button
            key={mode}
            type="button"
            data-user-guide={dataUserGuide}
            className={tabButtonClass}
            onClick={handleClick}
          >
            <TabIcon mode={mode} role={user?.role} />
            <span>{label}</span>
            <span className="font-normal text-muted-foreground">{count}</span>
          </button>
        );
      })}
    </div>
  );
}

export default DisplayModeButtonTabs;
